import { ConsumptionType } from '../../../ConsumptionType';
import { DrmScheme, MediaType, Resolution } from '@quickplay/player-interface';

/**
 * Delivery type of content
 */
export enum DeliveryType {
  STREAMING = 'streaming',
  DOWNLOAD = 'download',
}

export enum PlaybackMode {
  LIVE = 'live',
  RESTART = 'restart',
  CATCHUP = 'catchup',
  LIVE360 = 'live360',
}

/**
 * @property deviceName the unique name of device.
 * @property deviceId the unique id of device.
 * @property contentId the unique id of content.
 * @property contentTypeId the unique id of content type.
 * @property catalogType the the catalog type.
 * @property mediaFormat the media format of content.
 * @property drm the unique secret key  of content.
 * @property delivery
 * @property disableSsai whether Server Side Ad Insertion is enabled or not.
 * @property startTime the start time of the content.
 * @property endTime the end time of the content.
 * @property playbackMode the playback mode.
 * @property eventId the unique id of event.
 * @property castDeviceId the unique id of cast device.
 * @property deviceManufacturer represents the maufacturer of the device.
 * @property deviceModelName the unique name of the device.
 * @property deviceModelNumber the unique number of the device.
 * @property deviceYear the device year.
 * @property deviceOs the represents the operating system used in device.
 * @property deviceOsVersion represents OS version used in the device.
 * @property deviceToken unique token represents the device.
 * @property supportedResolution the supported resolution.
 * @property supportedAudio the supported audio.
 * @property supportedAudioCodecs the supported audio codecs.
 * @property supportedVideoCodecs the supported video codecs.
 * @property supportedMaxWVSecurityLevel the supported WV Security level
 * @property supportedHdrCapabilities the supported HDR formats.
 * @property urlParameters map with Ad targeting parameters.
 * @property prid primary content unique identifier
 * @property custom tenant specigic custom data
 */
export interface PlaybackAuthorizationRequestData {
  deviceName: string;
  deviceId: string;
  contentId: string;
  contentTypeId: ConsumptionType;
  catalogType: string;
  mediaFormat: MediaType;
  drm: DrmScheme;
  delivery: DeliveryType;
  disableSsai?: string;
  disableCsai?: string;
  startTime?: string;
  endTime?: string;
  playbackMode?: PlaybackMode;
  eventId?: string;
  castDeviceId?: string;
  deviceManufacturer?: string;
  deviceModelName?: string;
  deviceModelNumber?: string;
  deviceYear?: string;
  deviceOs?: string;
  deviceOsVersion?: string;
  deviceToken: string;
  supportedResolution?: Resolution;
  supportedAudio?: string;
  supportedAudioCodecs?: string;
  supportedVideoCodecs?: string;
  supportedMaxWVSecurityLevel?: string;
  supportedHdrCapabilities?: string;
  urlParameters?: { [key: string]: any };
  prid?: string;
  custom?: { [key: string]: any };
}
